import { render } from "./RegionModeratorForm.vue?vue&type=template&id=94f593d6"
import script from "./RegionModeratorForm.vue?vue&type=script&lang=js"
export * from "./RegionModeratorForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__